<!-- 获取车辆屏显及语音接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {

          "parkCode": "2KNTYVWC"
        },
        responseCode: {
          "data": {
            "parkCode": "2KNTYVWC",
            "eptCarports": "111"
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台 获取车辆免费停车信息",
          t_url: this.commonUrls.test + "getCarFreeParkingInfo",
          p_url: this.commonUrls.prod + "getCarFreeParkingInfo",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '停车场编号'
              },
              {
                info1: 'carCode',
                info2: '否',
                info3: 'String',
                info4: '车牌号码'
              },
              {
                info1: 'parkingCode',
                info2: '是',
                info3: 'String',
                info4: '停车记录编号'
              }, {
                info1: 'vipType',
                info2: '否',
                info3: 'Integer',
                info4: '进场VIP类型'
              }, {
                info1: 'isSupportSpecialChargeRule',
                info2: '否',
                info3: 'Boolean',
                info4: '是否支持特殊计费规则(默认false)'
              }, {
                info1: 'isSupportTriggerEvent',
                info2: '否',
                info3: 'Boolean',
                info4: '是否支持触发事件(默认false)'
              }
            ]
          }],
          R_params: [{
              titleName: null,
              tabledata: [{
                tableHead: '参数名',
                tdName: 'info1'
              }, {
                tableHead: '是否必填',
                tdName: 'info2'
              }, {
                tableHead: '类型',
                tdName: 'info3'
              }, {
                tableHead: '说明',
                tdName: 'info4'
              }],
              td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '车场编号'
              },
              {
                info1: 'carCode',
                info2: '是',
                info3: 'String',
                info4: '车牌号码'
              },{
                info1: 'carCodeColor',
                info2: '否',
                info3: 'Integer',
                info4: '车牌颜色'
              },{
                info1: 'parkingCode',
                info2: '是',
                info3: 'String',
                info4: '停车记录编号'
              },{
                info1: 'enterVipType',
                info2: '否',
                info3: 'Integer',
                info4: '进场VIP类型'
              },{
                info1: 'enterTime',
                info2: '是',
                info3: 'String',
                info4: '进场时间(yyyyMMddHHmmss)'
              },{
                info1: 'leaveTime',
                info2: '是',
                info3: 'String',
                info4: '免费离场时间(yyyyMMddHHmmss)'
              },{
                info1: 'isFree',
                info2: '是',
                info3: 'Integer',
                info4: '是否免费: 0否，1是'
              }
              ]
            }


          ],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: [{
              info1: '000110',
              info2: '失败',
            }, {
              info1: '00110000',
              info2: '失败',
            }, {
              info1: '110000',
              info2: '失败',
            }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getCarFreeParkingInfo.vue